import React, { Component } from "react";
import Input from "../common/Input";
import { NavLink, Router, Route } from "react-router-dom";
import PictureUpload from "../common/PictureUpload";
import Task from "../common/Task";
import { createBrowserHistory, createHashHistory } from "history";
import PasswordSettings from "./PasswordSettings";
import BackArrow from "../common/BackArrow";
import { connect } from "react-redux";
import API from "../common/Api";
const history = createBrowserHistory();
const mapStateToProps = (state) => ({
  userProfile: state.userProfile,
  headers: state.headers(),
});

export default connect(mapStateToProps)(
  class profileSettings extends Component {
    state = {
      loading: false,
      errors: {},
    };
    saveChanges = (ev) => {
      ev.preventDefault();
      this.setState({ loading: true });
      this.setState({ errors: {} });

      const form = ev.currentTarget;

      const body = new FormData(form);
      body.append("_method", "put");

      API({
        url: "profile",
        method: "POST",
        headers: {
          ...this.props.headers,
          Accept: "*/*",
        },
        data: body,
        transformRequest: [(data) => data]

      })
        .then(
          ({ data }) => {
            if (data.success) {
              this.refreshProfile();
              window.$.notify("Profile Updated", "success-alert");
            }
          },
          ({ response }) => {
            if (response?.data?.errors) {
              response.data.errors.map((err) => {
                this.setState({
                  errors: Object.assign(this.state.errors, {
                    [err.field]: err.message,
                  }),
                });
                window.$.notify(err.message, "error-alert");

                return err
              });
            }
          }
        )
        .finally(() => {
          this.setState({ loading: false });
        });
    };
    refreshProfile = () => {
      API.get(`profile`, { headers: this.props.headers }).then(({ data }) => {
        this.props.dispatch({ type: "GET_PROFILE", data: data.data });
      });
    };
    render() {
      return (
        <div className="onboarding-page profile-settings-page">
          <h1 className="form-title dsk flex center">Profile settings</h1>
          <div className="form_step form-page">
            <h1 className="form-title mbl flex center">
              <BackArrow />
              Profile settings
            </h1>
            <div className="form-container card">
              <form
                onSubmit={this.saveChanges}
                className="restrict"
                encType="multipart/form-data"
              >
                <PictureUpload
                  name="profile_picture"
                  defaultsrc={this.props.userProfile.profile_picture}
                />
                <NavLink
                  to={{ pathname: "/profile/settings/password" }}
                  className="dsk"
                >
                  <Task
                    title="Change login password"
                    svg={
                      <svg
                        width="16"
                        height="19"
                        viewBox="0 0 16 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 6.66668H14.6667C14.8877 6.66668 15.0996 6.75447 15.2559 6.91075C15.4122 7.06703 15.5 7.279 15.5 7.50001V17.5C15.5 17.721 15.4122 17.933 15.2559 18.0893C15.0996 18.2455 14.8877 18.3333 14.6667 18.3333H1.33333C1.11232 18.3333 0.900358 18.2455 0.744078 18.0893C0.587797 17.933 0.5 17.721 0.5 17.5V7.50001C0.5 7.279 0.587797 7.06703 0.744078 6.91075C0.900358 6.75447 1.11232 6.66668 1.33333 6.66668H3V5.83334C3 4.50726 3.52678 3.23549 4.46447 2.29781C5.40215 1.36013 6.67392 0.833344 8 0.833344C9.32608 0.833344 10.5979 1.36013 11.5355 2.29781C12.4732 3.23549 13 4.50726 13 5.83334V6.66668ZM11.3333 6.66668V5.83334C11.3333 4.94929 10.9821 4.10144 10.357 3.47632C9.7319 2.8512 8.88406 2.50001 8 2.50001C7.11594 2.50001 6.2681 2.8512 5.64298 3.47632C5.01786 4.10144 4.66667 4.94929 4.66667 5.83334V6.66668H11.3333ZM7.16667 11.6667V13.3333H8.83333V11.6667H7.16667ZM3.83333 11.6667V13.3333H5.5V11.6667H3.83333ZM10.5 11.6667V13.3333H12.1667V11.6667H10.5Z"
                          fill="#2A2B79"
                        />
                      </svg>
                    }
                  />
                </NavLink>
                <Input
                  label="First name"
                  name="first_name"
                  placeholder="Enter first name here"
                  defaultValue={this.props.userProfile.first_name}
                  disabled={!this.props.userProfile.first_name}
                  error={this.state.errors.first_name}
                  spellCheck={false}
                  type="text"
                  required
                />
                <Input
                  label="Last name"
                  type="text"
                  name="last_name"
                  defaultValue={this.props.userProfile.last_name}
                  disabled={!this.props.userProfile.last_name}
                  error={this.state.errors.last_name}
                  spellCheck={false}
                  placeholder="Enter last name here"
                  required
                />
                <Input
                  label="Email"
                  type="email"
                  name="email"
                  disabled={!this.props.userProfile.email}
                  defaultValue={this.props.userProfile.email}
                  error={this.state.errors.email}
                  spellCheck={false}
                  placeholder="Enter email here"
                  required
                />
                <Input
                  label="Phone number"
                  type="number"
                  name="phone_number"
                  defaultValue={this.props.userProfile.phone_number}
                  disabled={!this.props.userProfile.phone_number}
                  error={this.state.errors.phone_number}
                  placeholder="Enter phone number here"
                  required
                />
                <div className="footer flex center space-btw">
                  <button
                    className={`default ${this.state.loading ? "loading" : ""}
                    `}
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>

            <NavLink
              to={{ pathname: "/profile/settings/password" }}
              className="mbl"
            >
              <Task
                title="Change login password"
                svg={
                  <svg
                    width="16"
                    height="19"
                    viewBox="0 0 16 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 6.66668H14.6667C14.8877 6.66668 15.0996 6.75447 15.2559 6.91075C15.4122 7.06703 15.5 7.279 15.5 7.50001V17.5C15.5 17.721 15.4122 17.933 15.2559 18.0893C15.0996 18.2455 14.8877 18.3333 14.6667 18.3333H1.33333C1.11232 18.3333 0.900358 18.2455 0.744078 18.0893C0.587797 17.933 0.5 17.721 0.5 17.5V7.50001C0.5 7.279 0.587797 7.06703 0.744078 6.91075C0.900358 6.75447 1.11232 6.66668 1.33333 6.66668H3V5.83334C3 4.50726 3.52678 3.23549 4.46447 2.29781C5.40215 1.36013 6.67392 0.833344 8 0.833344C9.32608 0.833344 10.5979 1.36013 11.5355 2.29781C12.4732 3.23549 13 4.50726 13 5.83334V6.66668ZM11.3333 6.66668V5.83334C11.3333 4.94929 10.9821 4.10144 10.357 3.47632C9.7319 2.8512 8.88406 2.50001 8 2.50001C7.11594 2.50001 6.2681 2.8512 5.64298 3.47632C5.01786 4.10144 4.66667 4.94929 4.66667 5.83334V6.66668H11.3333ZM7.16667 11.6667V13.3333H8.83333V11.6667H7.16667ZM3.83333 11.6667V13.3333H5.5V11.6667H3.83333ZM10.5 11.6667V13.3333H12.1667V11.6667H10.5Z"
                      fill="#2A2B79"
                    />
                  </svg>
                }
              />
            </NavLink>
          </div>

          {/* convert to modal on desktop */}
          {window.innerWidth >= 600 ? (
            <Router history={history}>
              <Route
                exact
                path="/profile/settings/password"
                component={PasswordSettings}
              />
            </Router>
          ) : (
            ""
          )}
        </div>
      );
    }
  }
);
